// Libraries
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
// Actions
import { UpdatePatient } from '../../../actions/patient';
import ShowNotification from '../../../actions/notification';
// Constants
import { EMPTY_STRING } from '../../../constants/constants';

export function PatientAvailability(props) {
  const {
    patient: {
      enableSendingApptReminder = false,
      apptReminderResponseValue, otherApptResponseText, lastApptReminderDate,
    } = {},
  } = props;

  const getDateString = date => (moment(date).isValid()
    ? moment(moment.utc(date)).local().calendar() : EMPTY_STRING);

  return (
    enableSendingApptReminder && (
    <div className="d-flex-center-between box-wrapper p-2" data-test="patientAvailability_mainComponent">
      <span className="patient-summary-title text-uppercase">Patient Availability Check</span>
      <div>
        <span className="text-uppercase">
          Last sent:
        </span>
        <span className="ml-1" data-test="patientAvailability_lastApptDate">
          {getDateString(lastApptReminderDate)}
        </span>
      </div>
      <div className="d-flex-center">
        <div>
          <span className="text-uppercase">
            Response:
          </span>
          <span className="ml-1" data-test="patientAvailability_apptLabel">
            {apptReminderResponseValue || EMPTY_STRING}
          </span>
        </div>
        {otherApptResponseText && (
          <OverlayTrigger
            placement="right"
            overlay={(
              <Tooltip>
                {otherApptResponseText}
              </Tooltip>)}
          >
            <div className="rounded-circle bg-ccm-light-gray py-1 px-2 ml-2" data-test="patientAvailability_responseTooltip">
              <Button variant="link-dark" className="p-0"><i className="bi-chat-left-text" /></Button>
            </div>
          </OverlayTrigger>
        )}
      </div>
    </div>)
  );
}

function mapStateToProps(state) {
  return {
    patient: state.patient,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updatePatient: patientData => dispatch(UpdatePatient(patientData)),
    showNotification: notificationData => dispatch(ShowNotification(notificationData)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientAvailability);
